import { api } from "@/api";
import { ActividadComercial } from "@/shared/types/actividad-comercial";
import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface ActividadesComercalesQuery extends BaseQuery {
  codigo?: string,
  nombre?: string,
}

export async function getAllActividadesComerciales(query?: ActividadesComercalesQuery): Promise<QueryResponse<ActividadComercial>> {
  await sleep(1000);
  const response = await api.get("actividades_comerciales", { params: removeNullOrEmptyKeys(query) });
  return response.data;
}

export function useGetAllActividadesComercalesQuery(query: ActividadesComercalesQuery = {}, queryConfig: QueryConfig<QueryResponse<ActividadComercial>> = {}) {
  return useQuery({
    ...queryConfig,
    queryFn: async () => await getAllActividadesComerciales(query),
    queryKey: ["actividades_comerciales", query],
  })
}

export interface GetAllActividadesComercalesQueryProps {
  query: ActividadesComercalesQuery,
  queryConfig?: QueryConfig<QueryResponse<ActividadComercial>>,
  children: (queryResult: QueryResult<QueryResponse<ActividadComercial>>) => ReactNode
}

export function GetAllActividadesComercalesQuery({
  query,
  queryConfig,
  children
}: GetAllActividadesComercalesQueryProps) {
  const queryResult = useGetAllActividadesComercalesQuery(query, queryConfig);
  return children(queryResult);
}
